import { Divider, Flex, Skeleton } from '@components';

const FilterPanelSkeleton = () => {
	return (
		<Flex gap={4} column>
			{Array.from({ length: 2 }).map((_, index) => (
				<div key={index}>
					<Skeleton height={32} width='100%' type='line' borderRadius={'0.4rem'} />
					<Divider alignment='horizontal' />
					<div>
						<Skeleton height={200} width='100%' type='rect' borderRadius={'0.4rem'} />
					</div>
				</div>
			))}
		</Flex>
	);
};

export default FilterPanelSkeleton;
